<template>
  <header id="inicio" class="site-header">
    <Navbar />
    <div class="layout-jumbotron container-fluid">
      <h1 class="title">
        Siempre Frío,
        <br />Siempre a Tiempo
      </h1>
        <b-button pill variant="primary" size="lg" v-on:click="scrollToContact()">Contacto</b-button>
    </div>
  </header>
</template>

<script>
import Navbar from '../components/Navbar'
export default {
  name: 'Header',
  components: {
    Navbar
  },
  methods: {
    scrollToContact () {
      const el = document.getElementById('contacto')
      el.scrollIntoView()
    }
  }
}
</script>

<style scoped>
.site-header {
  background-image: url("../assets/Jumbotron.jpeg");
  background-size: cover;
  background-position: center center;
  height: 100vh;
}

.site-header .layout-jumbotron {
  background-repeat: no-repeat;
}
/*Phones*/
@media only screen and (max-width: 767px) {
  .site-header {
    background-image: url("../assets/JumbotronMobile.jpeg");
  }
  .title{
  padding-top: 75vh;
  color:white;
  font-weight: bolder;
  font-size: 5vh;
  font-style: italic;
  }
}

/*Tablets*/
@media only screen and (min-width: 768px) {
  .title{
  padding-top: 70vh;
  color:white;
  font-weight: bolder;
  font-size: 7vh;
  font-style: italic;
  }
}

/*Laptops*/
@media only screen and (min-width: 1026px) {
  .title{
    padding-top: 60vh;
    color:white;
    font-weight: bolder;
    font-size: 10vh;
    font-style: italic;
  }
}

</style>
